module.exports = __webpack_public_path__ + "img/tile-type_en.5875d54.jpg";